import type { I18nPrefix } from '../../i18n/prefix';

export const I18N_SCHEDULED_FOR_DELETION_ALERT_BAR =
  'features:alerts.components.scheduled_for_deletion_alert_bar' satisfies I18nPrefix;
export const I18N_RESTRICTED_SESSION_ALERT_BAR =
  'features:alerts.components.restricted_session_alert_bar' satisfies I18nPrefix;
